<template>
  <div class="container">
    <div class="card margin-top" v-if="!loading">
      <div class="title-register">
        <h3
          class="font-moul"
          style="font-size:14px; text-align:center;line-height: 26px;"
        >
          {{$t("message.application_form")}}
        </h3>
        <div>
          <div class="justify-center text-center">
            <div
              class="p-12 border bg-image bg-gray-100"
              @dragover="dragover"
              @dragleave="dragleave"
              @drop="drop"
            >
              <span>
                <label for="assetsFieldHandle" class="cursor-pointer">
                  <div>
                    Photo 4x6 (រូបថត ៤x៦)
                  </div>
                </label>
                <label
                  class="custom-file-upload btn btn-primary"
                  :class="{ 'custom-file-upload-image': form.avatar }"
                >
                  <input
                    type="file"
                    name="fields[assetsFieldHandle][]"
                    @change="onChange"
                    ref="file"
                    accept=".jpg,.jpeg,.png"
                  />
                  {{$t("message.choose_image")}}
                </label>
              </span>
              <div v-if="form.avatar" class="image-photo-cover">
                <img class="image-photo" :src="form.avatar" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="card">
          <div class="card-body" style="margin:auto;width:80%;">
            <form v-on:submit.prevent>
              <div class="card-body border" style="background-color: rgb(213 237 243);">
                <p>ខ្ញុំសូមស្នើសុំចូលរួម៖ I would like to apply for <span class="text-danger">*</span>:</p>
                <div style="padding:2px 10px;">
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="training"
                      value="1"
                      v-model="form.register.apply_for"
                      name="trainingType"
                      :class="{ 'is-invalid': v$.form.register.apply_for.$error }"
                    />
                    <label class="form-check-label" for="training">
                      វគ្គបណ្តុះបណ្តាលនិងការប្រឡង (Training and Examination)
                    </label>
                  </div>
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="radio"
                      value="2"
                      id="cpe"
                      v-model="form.register.apply_for"
                      name="trainingType"
                      :class="{ 'is-invalid': v$.form.register.apply_for.$error }"
                    />
                    <label class="form-check-label" for="cpe">
                      កម្មវិធីអប់រំវិជ្ជាជីវៈបន្ត (CPE)
                    </label>
                  </div>
                  <div class="md-3 row" v-if="form.register.apply_for == 2">
                    <label class="col-sm-4 col-form-label"
                      >កាលបរិច្ឆេទផុតសុពលភាព (Expiry Date) :</label
                    >
                    <div class="col-sm-6">
                      <input
                        type="text"
                        class="form-control"
                        v-maska="'##/##/####'"
                        v-model="form.register.cpe_expire"
                        placeholder="កាលបរិច្ឆេទផុតសុពលភាព (Expiry Date)"
                      />
                    </div>
                  </div>

                  <p style="margin-top:10px;">
                    <b>បញ្ជាក់ (Note)៖</b>
                    បុគ្គលដាក់ពាក្យស្នើសុំចូលរួមកម្មវិធីអប់រំវិជ្ជាជីវៈបន្ត
                    សូមរំលងចំណុច “ឃ” និង “ង” Those who apply for CPE program,
                    please skip points “D” and “E”
                  </p>
                </div>
              </div>
              <h3 class="title font-moul bg-color-light-green">
                ក.ប្រភេទអាជីវកម្ម (A. TYPE OF BUSINESS)
              </h3>
              <div class="card-body border">
                <div class="row">

                <label for="first-name" class="form-label">សូមជ្រើសរើសប្រភេទអាជីវកម្ម/Please choose type of business <span class="text-danger">*</span></label>
                <div class="input-group mb-3">
                  <select
                    class="form-select"
                    v-model="form.bussiness_cat"
                    :class="{ 'is-invalid': v$.form.bussiness_cat.$error }"
                  >
                    <option value="" selected>Choose...</option>
                    <option value="1">{{$t("message.stock_business")}}</option>
                    <option value="2">{{$t("message.derivative_business")}}</option>
                    <option value="3">{{$t("message.public")}}</option>
                  </select>
                </div>
                <div v-if="form.bussiness_cat">

                  <div v-if="form.bussiness_cat==3">
                      <div class="form-check" v-for="item in filterbussinessType"
                          :key="item.id">
                        <input
                          class="form-check-input"
                          type="radio"
                          :id="item.id + '_'"
                          :value="item.id"
                          v-model="form.bussiness_public_cat"
                          name="pub"
                        />
                        <label class="form-check-label" :for="item.id + '_'">
                          {{ item.name }} ({{ item.name_en }})
                        </label>
                      </div>
                  </div>

                  <div
                    v-else 
                    class="col-sm-12"
                    v-for="item in filterbussinessType"
                    :key="item.id"
                  >
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        v-model="item.value"
                        @change="checkbusinesstype(item)"
                        :id="item.id + '_'"
                      />
                      <label class="form-check-label" :for="item.id + '_'">
                        {{ item.name }} ({{ item.name_en }})
                      </label>
                    </div>
                  </div>
                  </div>
                </div>
              </div>
              <h3 class="title font-moul bg-color-light-green">
                ខ. ព័ត៌មានផ្ទាល់ខ្លួន (B. PERSONAL INFORMATION)
              </h3>
              <div class="card-body border">
                <label for="lastname-firstname" class="form-label"
                  >គោត្តនាម-នាម(អក្សរខ្មែរ)/Full Name In Khmer <span class="text-danger">*</span></label
                >
                <div class="input-group mb-3">
                  <input
                    type="text"
                    v-model.trim="form.lastname"
                    aria-label="Last name"
                    class="form-control"
                    placeholder="គោត្តនាម"
                    :class="{ 'is-invalid': v$.form.lastname.$error }"
                  />
                  <input
                    type="text"
                    v-model.trim="form.firstname"
                    aria-label="First name"
                    class="form-control"
                    placeholder="នាម"
                    :class="{ 'is-invalid': v$.form.firstname.$error }"
                  />
                </div>

                <label for="lastname-firstname-latine" class="form-label"
                  >គោត្តនាម-នាម(អក្សរឡាតាំង)/Full Name Latin <span class="text-danger">*</span></label
                >
                <div class="input-group mb-3">
                  <!-- <span class="input-group-text">Last and Frist name (Latine)</span> -->
                  <input
                    type="text"
                    v-model="form.lastname_en"
                    aria-label="Last name"
                    class="form-control"
                    :class="{ 'is-invalid': v$.form.lastname_en.$error }"
                  />
                  <input
                    type="text"
                    v-model="form.firstname_en"
                    aria-label="First name"
                    class="form-control"
                    :class="{ 'is-invalid': v$.form.firstname_en.$error }"
                  />
                </div>

                <label for="first-name" class="form-label">ភេទ/Gender <span class="text-danger">*</span></label>
                <div class="input-group mb-3">
                  <select
                    class="form-select"
                    v-model="form.gender"
                    id="inputGroupSelect01"
                    :class="{ 'is-invalid': v$.form.gender.$error }"
                  >
                    <option selected>Choose...</option>
                    <option value="1">ប្រុស (Male)</option>
                    <option value="2">ស្រី (Female)</option>
                  </select>
                </div>

                <label for="first-name" class="form-label">ស្ថានភាពគ្រួសារ/Marital Status <span class="text-danger">*</span></label>
                <div class="input-group mb-3">
                  <select
                    class="form-select"
                    v-model="form.marital_status"
                    id="inputGroupSelect01"
                    :class="{ 'is-invalid': v$.form.marital_status.$error }"
                  >
                    <option selected>Choose...</option>
                    <option value="1">នៅលីវ (Single)</option>
                    <option value="2">បានរៀបការ (Married)</option>
                  </select>
                </div>

                <label for="dob" class="form-label">ថ្ងៃខែឆ្នាំកំណើត/Date of Birth <span class="text-danger">*</span></label>
                <div class="input-group mb-3">
                  <input
                    v-maska="'##/##/####'"
                    v-model="form.dob"
                    class="form-control"
                    id="dob"
                    placeholder=""
                    aria-label="date_of_birth"
                    aria-describedby="dob2"
                    :class="{ 'is-invalid': v$.form.dob.$error }"
                  />
                </div>

                <label for="nationality" class="form-label">សញ្ជាតិ/Nationality <span class="text-danger">*</span></label>
                <div class="input-group mb-3">
                  <select
                    id="nationality"
                    v-model="form.nationality"
                    class="form-select"
                    aria-label="Default select example"
                    searchable="Search here.."
                    :class="{ 'is-invalid': v$.form.nationality.$error }"
                  >
                    <option selected>Open this select menu</option>
                    <option
                      v-for="item in countryCode"
                      :key="item.id"
                      :value="item.id"
                      >{{ item.name }}</option
                    >
                  </select>
                </div>
                <label for="lastname-firstname" class="form-label"
                  >លេខអត្តសញ្ញាណបណ្ណសញ្ញាតិខ្មែរ ឬលេខលិខិតឆ្លងដែន/National ID Card or Passort <span class="text-danger">*</span></label
                >
                <div class="input-group mb-3">
                  <input
                    type="text"
                    class="form-control"
                    v-model="form.national_id_card"
                    :class="{ 'is-invalid': v$.form.national_id_card.$error }"
                    aria-describedby="idcard"
                  />
                </div>

                <label for="lastname-firstname" class="form-label"
                  >លេខទូរសព្ទ/Phone Number <span class="text-danger">*</span></label
                >
                <div class="input-group mb-3">
                  <input
                    type="text"
                    v-maska="'##########'"
                    v-model="form.phone"
                    class="form-control"
                    id="basic-url"
                    aria-describedby="phone2"
                    :class="{ 'is-invalid': v$.form.phone.$error }"
                  />
                </div>

                <label for="lastname-firstname" class="form-label"
                  >អ៉ីមែល/Email <span class="text-danger">*</span></label
                >
                <div class="input-group mb-3">
                  <input
                    type="text"
                    v-model="form.email"
                    class="form-control"
                    :class="{ 'is-invalid': v$.form.email.$error }"
                  />
                </div>
                
                <label for="lastname-firstname" class="form-label"
                  >អាសយដ្ឋាន Address*</label
                >
                <div class="row mb-2">
                  <div class="col-md-4">
                    <label class="form-label">ផ្ទះលេខ-House N0 </label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="form.house_number"
                      placeholder="ផ្ទះលេខ-House N0"
                      
                    />
                  </div>

                  <div class="col-md-4">
                    <label class="form-label">ផ្លូវ-Street </label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="form.street"
                      placeholder="ផ្លូវ-Street"
                      
                    />
                  </div>

                  <div class="col-md-4">
                    <label class="form-label">ភូមិ-Village </label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="form.village"
                      placeholder="ភូមិ-Village"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <label class="form-label">ឃុំ/សង្កាត់-Commune <span class="text-danger">*</span></label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="form.commune"
                      placeholder="ឃុំ/សង្កាត់-Commune"
                      :class="{ 'is-invalid': v$.form.commune.$error }"
                    />
                  </div>

                  <div class="col-md-4">
                    <label class="form-label">ក្រុង/ស្រុក/ខណ្ឌ-District <span class="text-danger">*</span></label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="form.district"
                      placeholder="ក្រុង/ស្រុក/ខណ្ឌ-District"
                      :class="{ 'is-invalid': v$.form.district.$error }"
                    />
                  </div>
                  <div class="col-md-4">
                    <label class="form-label"
                      >រាជធានី/ខេត្ត-City/Province <span class="text-danger">*</span></label
                    >
                    <input
                      type="text"
                      class="form-control"
                      v-model="form.city_province"
                      placeholder="រាជធានី/ខេត្ត-City/Province"
                      :class="{ 'is-invalid': v$.form.city_province.$error }"
                    />
                  </div>
                </div>
              </div>
              <h3 class="title font-moul bg-color-light-green">
                គ. ព័ត៌មានអំពីមុខរបរ (C. OCCUPATION)
              </h3>
              <div class="card-body border">
                <div class="row mb-2">
                  <div class="col-md-4">
                    <label class="form-label"
                      >មុខរបរបច្ចុប្បន្ន/Current Occupation <span class="text-danger">*</span></label
                    >
                    <input
                      type="text"
                      class="form-control"
                      v-model="form.occupations.occupation"
                      placeholder="មុខរបរបច្ចុប្បន្ន/Current Occupation"
                      :class="{ 'is-invalid': v$.form.occupations.occupation.$error }"
                    />
                  </div>
                  <div class="col-md-4">
                    <label class="form-label"
                      >ឈ្មោះក្រុមហ៊ុន/Company Name <span class="text-danger">*</span></label
                    >
                    <input
                      type="text"
                      class="form-control"
                      v-model="form.occupations.company"
                      placeholder="ឈ្មោះក្រុមហ៊ុន/Company Name"
                      :class="{ 'is-invalid': v$.form.occupations.company.$error }"
                    />
                  </div>
                  <div class="col-md-4">
                    <label class="form-label"
                      >រយៈពេលអតីតភាពការងារ/Duration of Experience <span class="text-danger">*</span></label
                    >
                    <input
                      type="text"
                      class="form-control"
                      v-model="form.occupations.duration_experience"
                      placeholder="រយៈពេលអតីតភាពការងារ/Duration of Experience "
                      :class="{ 'is-invalid': v$.form.occupations.duration_experience.$error }"
                    />
                  </div>
                </div>

                <div class="row mb-2">
                  <div class="col-md-4">
                    <label class="form-label">ឃុំ/សង្កាត់/Commune <span class="text-danger">*</span></label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="form.occupations.commune"
                      placeholder="ឃុំ/សង្កាត់/Commune"
                      :class="{ 'is-invalid': v$.form.occupations.commune.$error }"
                    />
                  </div>
                  <div class="col-md-4">
                    <label class="form-label">ក្រុង/ស្រុក/ខណ្ឌ/District <span class="text-danger">*</span></label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="form.occupations.district"
                      placeholder="ក្រុង/ស្រុក/ខណ្ឌ/District"
                      :class="{ 'is-invalid': v$.form.occupations.district.$error }"
                    />
                  </div>
                  <div class="col-md-4">
                    <label class="form-label"
                      >រាជធានី/ខេត្ត/City/Province <span class="text-danger">*</span></label
                    >
                    <input
                      type="text"
                      class="form-control"
                      v-model="form.occupations.city_province"
                      placeholder="រាជធានី/ខេត្ត/City/Province"
                      :class="{ 'is-invalid': v$.form.occupations.city_province.$error }"
                    />
                  </div>
                </div>

                <div class="row mb-2">
                  <div class="col-md-4">
                    <label class="form-label">ទូរសព្ទលើតុ/Telephone <span class="text-danger">*</span></label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="form.occupations.telephone"
                      placeholder="ទូរសព្ទលើតុ/Telephone"
                      :class="{ 'is-invalid': v$.form.occupations.telephone.$error }"
                    />
                  </div>
                  <div class="col-md-4">
                    <label class="form-label">សារអេឡិចត្រូនិច/E-mail</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="form.occupations.email"
                      placeholder="សារអេឡិចត្រូនិច/E-mail"
                    />
                  </div>
                  <div class="col-md-4">
                    <label class="form-label">គេហទំព័រ/Website</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="form.occupations.website"
                      placeholder="គេហទំព័រ/Website"
                    />
                  </div>
                </div>
              </div>
              <div >
                <div class="row">
                  <div class="col-sm-11">
                    <h3 class="title font-moul bg-color-light-green">
                      ឃ. ប្រវត្តិការសិក្សា (D. EDUCATIONAL BACKGROUND)
                    </h3>
                  </div>
                  <div class="col-sm-1" style="text-align:right;">
                    <button class="btn-incress" @click="increaseEducation">
                      <i class="fa fa-plus text-primary text-lg"></i>
                    </button>
                  </div>
                </div>
                <div class="card-body border">
                  <table class="table table-bordered">
                    <thead>
                      <tr>
                        <td class="text-center">កម្រិតវប្បធម៌/Degree</td>
                        <td class="text-center">ជំនាញMajor/Subject</td>
                        <td class="text-center">
                          គ្រឹះស្ថានអប់រំ/Educational Institution
                        </td>
                        <td class="text-center"></td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(education, index) in form.education_backgrounds"
                        :key="education + '_' + index"
                      >
                        <td>
                          <input
                            type="text"
                            class="form-control"
                            v-model="education.degree"
                            placeholder=""
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            class="form-control"
                            v-model="education.major_subject"
                            placeholder=""
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            class="form-control"
                            v-model="education.educational_institution"
                            placeholder=""
                          />
                        </td>
                        <td class="text-center">
                          <button
                            class="btn-decress"
                            @click="decreaseEducation(index)"
                          >
                            <i class="fa fa-minus text-danger text-lg"></i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div >
                <div class="row">
                  <div class="col-sm-11">
                    <h3 class="title font-moul bg-color-light-green">
                      ង. បទពិសោធន៍ការងារ (E. WORK EXPERIENCE)
                    </h3>
                  </div>
                  <div class="col-sm-1" style="text-align:right;">
                    <button class="btn-incress" @click="increaseWorkExpirence">
                      <i class="fa fa-plus text-primary text-lg"></i>
                    </button>
                  </div>
                </div>
                <div class="card-body border">
                  <table class="table table-bordered">
                    <thead>
                      <tr>
                        <td class="text-center">
                          ឈ្មោះកន្លែងធ្វើការ/Name of Organization
                        </td>
                        <td class="text-center">មុខដំណែង/Position</td>
                        <td class="text-center">
                          ចាប់ផ្តើម/From
                        </td>
                        <td class="text-center">
                          រហូតដល់/To
                        </td>
                        <td class="text-center"></td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(exp, index) in form.workexperiences"
                        :key="workexperiences + '_' + index"
                      >
                        <td>
                          <input
                            type="text"
                            v-model="exp.name_organization"
                            class="form-control"
                            placeholder=""
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            v-model="exp.position"
                            class="form-control"
                            placeholder=""
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            v-model="exp.form_date"
                            class="form-control"
                            placeholder=""
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            v-model="exp.to_date"
                            class="form-control"
                            placeholder=""
                          />
                        </td>
                        <td class="text-center">
                          <button
                            class="btn-decress"
                            @click="decreaseWorkExpirence(index)"
                          >
                            <i class="fa fa-minus text-danger text-lg"></i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <h3 class="title font-moul bg-color-light-green">
                ច. បុគ្គលទំនាក់ទំនង (F. CONTACT PONSON)
              </h3>
              <div class="card-body border">
                <div class="row mb-2">
                  <div class="col-md-6">
                    <label class="form-label">ឈ្មោះ/Name <span class="text-danger">*</span></label>
                    <input
                      type="text"
                      v-model="form.contact_persons.name"
                      class="form-control"
                      placeholder="ឈ្មោះ/Name"
                      :class="{ 'is-invalid': v$.form.contact_persons.name.$error }"
                    />
                  </div>
                  <div class="col-md-6">
                    <label class="form-label">ភេទ/Gender <span class="text-danger">*</span></label>
                    <div class="input-group mb-3">
                      <select
                        class="form-select"
                        v-model="form.contact_persons.gender"
                        placeholder="ភេទ/Gender"
                        title="ភេទ/Gender"
                        :class="{ 'is-invalid': v$.form.contact_persons.gender.$error }"
                      >
                        <option selected>Choose...</option>
                        <option value="1">ប្រុស (Male)</option>
                        <option value="2">ស្រី (Female)</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col-md-6">
                    <label class="form-label">លេខទូរសព្ទ/Phone <span class="text-danger">*</span></label>
                    <input
                      type="text"
                      v-model="form.contact_persons.phone"
                      class="form-control"
                      placeholder="លេខទូរសព្ទ/Phone"
                      :class="{ 'is-invalid': v$.form.contact_persons.phone.$error }"
                    />
                  </div>
                  <div class="col-md-6">
                    <label class="form-label"
                      >សារអេឡិចត្រូនិច/E-mail Address </label
                    >
                    <div class="input-group mb-3">
                      <input
                        type="text"
                        v-model="form.contact_persons.email"
                        class="form-control"
                        placeholder="សារអេឡិចត្រូនិច/E-mail Address"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <h3 class="title font-moul bg-color-light-green">ឆ. ឯកសារ (G. ATTACHMENT)</h3>
              <div class="card-body border">
                  <div class="row ">
                    <div class="col-md-12">
                      <p class="text-center">រូបភាពអត្តសញ្ញាណប័ណ្ណ/Photo of National ID Card (jpg, jpeg, png) 
                        <span class="text-danger">*</span> 
                      </p>
                      <div class="att_cont bg-gray-100 border">
                        <div v-if="form.id_card" class="coverIdCard">
                          <img class="img-idcard" :src="form.id_card" />
                        </div>
                      </div>
                      <div class="text-center m-2">
                       <label
                          class="custom-file-upload btn btn-primary"
                        >
                          <input
                            type="file"
                            ref="otherIdCard"
                            name="idcard"
                            accept=".jpg,.jpeg,.png"
                            v-on:change="handleFilesUpload()"
                          />
                          {{$t("message.choose_image")}}
                        </label>
                      </div>
                    </div>
                  </div>
              </div>

              <h3 class="title font-moul bg-color-light-green">ជ. សេចក្តីប្រកាស (H. DECLARATION)</h3>
              <div class="card-body border">
                <div class="row">
                  <div class="col-sm-12">
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value=true
                        v-model="form.register.agree"
                        id="agree_kh"
                        @click="checkAgree($event)"
                      />
                      <label for="agree_kh" class="form-check-label">
                        សូមធានាថារាល់ព័ត៌មាន
                        និងឯកសារដែលបានផ្តល់ជូនគឺពិតជាត្រឹមត្រូវ។
                        ប្រសិនបើមានការក្លែងបន្លំ
                        ខ្ញុំសូមទទួលខុសត្រូវចំពោះមុខច្បាប់ជាធរមាន។
                      </label>
                    </div>
                  </div>
                  <div class="col-sm-12">
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value=true
                        v-model="form.register.agree"
                        id="agree"
                        @click="checkAgree($event)"
                      />
                      <label for="agree" class="form-check-label">
                        I hereby certify that the information on this
                        application is true and correct. I understand that
                        failure to provide true and correct information could
                        result in penalties under state law.
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              <div class="saveNext">

                <button
                  @click="$router.go(-1)"
                  type="button"
                  class="btn btn-secondary me-2"
                >
                  <i class="fas fa-arrow-left"></i>
                  {{$t("message.back")}}
                </button>
                <button
                    @click="updateRegistration"
                    :disabled="!form.register.agree"
                    type="button"
                    id="get-sign-in-code"
                    class="btn btn-primary"
                  >
                    {{$t("message.save")}}
                </button>

                
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div v-else style="height:500px;">

    </div>
  </div>
</template>
<script>
import useVuelidate from "@vuelidate/core";
import { required , email } from "@vuelidate/validators";
import { mapActions, mapGetters } from "vuex";
import axios from "@/axios";
export default {
  setup() {
    return {
      v$: useVuelidate()
    };
  },
  data() {
    return {
      form: {},
      filelist: "",
      fileurl: "",
      fileIdCard: "",
      fileIdCardUrl: "",
      error: {
        'idcard': false,
        'photo': false
      },
      loading: true,
    };
  },
  validations() {
    return {
        form: {
          firstname: { required, $autoDirty: true },
          lastname: { required, $autoDirty: true },
          firstname_en: { required, $autoDirty: true },
          lastname_en: { required, $autoDirty: true },
          gender: { required, $autoDirty: true },
          marital_status: { required, $autoDirty: true },
          dob: { required, $autoDirty: true },
          nationality: { required, $autoDirty: true },
          national_id_card: { required, $autoDirty: true },
          phone: { required, $autoDirty: true },
          email: { required, email, $autoDirty: true },
          bussiness_cat: { required, $autoDirty: true },
          commune: { required, $autoDirty: true },
          district: { required, $autoDirty: true },
          city_province: { required, $autoDirty: true },
          register: {
            apply_for:{ required, $autoDirty: true },
          },
          occupations:{
            occupation: { required, $autoDirty: true },
            company: { required, $autoDirty: true },
            duration_experience: { required, $autoDirty: true },
            commune: { required, $autoDirty: true },
            district: { required, $autoDirty: true },
            city_province: { required, $autoDirty: true },
            telephone: { required, $autoDirty: true },
          },
          contact_persons: {
            name: { required, $autoDirty: true },
            gender: { required, $autoDirty: true },
            phone: { required, $autoDirty: true },
          },
        }
    };
  },
  computed: {
    ...mapGetters({
      getParticipant: "getParticipant",
      getBusinessType: "getBusinessType",
      countryCode: "getCountryCode"
    }),
    filterbussinessType(){
        return this.form.getBusinessType.filter(e=>e.type==this.form.bussiness_cat);
    }
  },
  methods: {
    ...mapActions(["act_loadBusinessType"]),
    checkbusinesstype(v) {
      console.log(this.form,v);
    },
     showLoader() {
        return this.$loading.show({
            container: this.$refs.formContainer,
            color: "#01B201",
            canCancel: true,
            onCancel: this.onCancelLoader
        });
    },
    increaseEducation() {
      this.form.education_backgrounds.push({
        id: "",
        participant_id: "",
        user_id: "",
        degree: "",
        major_subject: "",
        educational_institution: ""
      });
    },
    decreaseEducation(v) {
      this.form.education_backgrounds = this.form.education_backgrounds.filter(
        function(obj, index) {
          return index !== v;
        }
      );
    },
    increaseWorkExpirence() {
      this.form.workexperiences.push({
        id: "",
        participant_id: "",
        user_id: "",
        name_organization: "",
        position: "",
        form_date: "",
        to_date: ""
      });
    },
    decreaseWorkExpirence(v) {
      this.form.workexperiences = this.form.workexperiences.filter(function(
        obj,
        index
      ) {
        return index !== v;
      });
    },
    checkAgree(v){
      this.v$.$validate();
      if (this.v$.$error) {
        //console.log("it is errors:",this.v$.$errors);
        if(!this.fileIdCardUrl){
          this.error.idcard = true;
        }
        if(!this.fileurl){
          this.error.photo = true;
        }
        this.form.register.agree = false;
        v.target.checked = false;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }else{
        if(!this.fileIdCardUrl){
          this.error.idcard = true;
          this.form.register.agree = false;
          v.target.checked = false;
        }
        if(!this.fileurl){
          this.error.photo = true;
          this.form.register.agree = false;
          v.target.checked = false;
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      }
    },
    async onChange() {
      this.filelist = this.$refs.file.files;
      const file = this.filelist[0];
      this.fileurl = URL.createObjectURL(file);
      let photoFormData = new FormData();
      photoFormData.append("file", this.filelist[0]);
      photoFormData.append("object_type", "photo");
      photoFormData.append("object_id", this.form.id);
      const respone = await axios.post("media-file", photoFormData, {
          headers: {
            Authorization: "Bearer " + this.$store.getters.getAuthToken
          }
      });
      if (respone.status == 201) {
        this.form.avatar = respone.data.data.filepath;
      }
    },
    dragover(event) {
      event.preventDefault();
      // Add some visual fluff to show the user can drop its files
      if (!event.currentTarget.classList.contains("bg-green-300")) {
        event.currentTarget.classList.remove("bg-gray-100");
        event.currentTarget.classList.add("bg-green-300");
      }
    },
    dragleave(event) {
      // Clean up
      event.currentTarget.classList.add("bg-gray-100");
      event.currentTarget.classList.remove("bg-green-300");
    },
    drop(event) {
      event.preventDefault();
      this.$refs.file.files = event.dataTransfer.files;
      this.onChange(); // Trigger the onChange event manually
      // Clean up
      event.currentTarget.classList.add("bg-gray-100");
      event.currentTarget.classList.remove("bg-green-300");
    },
   async handleFilesUpload(){
      const fileIdCard = this.$refs.otherIdCard.files;
      let photoFormData = new FormData();
      photoFormData.append("file", fileIdCard[0]);
      photoFormData.append("object_type", "id_card");
      photoFormData.append("object_id", this.form.id);
      const respone = await axios.post("media-file", photoFormData, {
          headers: {
            Authorization: "Bearer " + this.$store.getters.getAuthToken
          }
      });
      if (respone.status == 201) {
        this.form.id_card = respone.data.data.filepath;
      }
    },
    async loadDataRegistration(){
        let loader = this.showLoader();
        const respone = await axios.get("get-registration/" + this.$route.params.id, {
            headers: {
              Authorization: "Bearer " + this.$store.getters.getAuthToken
            }
        });
        if (respone.status == 200) {
            this.form = respone.data.data;
        }
        loader.hide();
        this.loading = false;
    },
    async updateRegistration(){
      this.v$.$validate(); // checks all inputs
      if (!this.v$.$error) {
        this.$swal
          .fire({
            title: "តើអ្នកចង់ចុះឈ្មោះមែនទេ?",
            showCancelButton: true,
            confirmButtonText: `យល់ព្រម`,
            cancelButtonText: `បោះបង់`
          })
          .then(async (result) => {
            if (result.isConfirmed) {
                console.log('this is change',this.form);
                const respone = await axios.put("update-register/"+this.$route.params.id, this.form, {
                  headers: {
                    Authorization: "Bearer " + this.$store.getters.getAuthToken
                  }
                });
                if (respone.status == 200) {
                    console.log('it is data:',respone.data);

                    if(respone.data.success==false){
                      this.$toast.open({
                          message: respone.data.message,
                          type: "error",
                          duration: 5000,
                          dismissible: true,
                          position: "top-right"
                        });
                    }else{
                      this.$toast.open({
                          message: 'Your form successfull saved!',
                          type: "success",
                          duration: 5000,
                          dismissible: true,
                          position: "top-right"
                        });
                    }       
                }
            }
          });
      }else{
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    }
  },
  created() {
    //load business type
    this.act_loadBusinessType();
    this.loadDataRegistration();
  },
  mounted() {
    if (typeof this.$store.getters.getAuth.access_token === "undefined") {
      this.$router.push({ name: "SingUp" });
    }
  }
};
</script>
<style scoped>
.title {
  margin: 10px 0;
  font-size: 14px;
}
.border {
  border: 1px solid #f1f1f1;
}
.btn-incress {
  width: 30px;
  height: 30px;
  padding: 6px 0px;
  border-radius: 15px;
  text-align: center;
  font-size: 12px;
  line-height: 1.42857;
  border: 1px solid #0d6efd !important;
  margin-top: 8px;
}
.btn-decress {
  width: 30px;
  height: 30px;
  padding: 6px 0px;
  border-radius: 15px;
  text-align: center;
  font-size: 12px;
  line-height: 1.42857;
  border: 1px solid #dc3545 !important;
}
.btn-incress:focus,
.btn-decress:focus {
  outline: none;
  border: 1px solid #ccc;
}
input[type="file"] {
  display: none;
}
.button-choose {
  position: relative;
}
.bg-image {
  width: 220px;
  height: 220px;
}
.bg-gray-100 {
  background-color: rgb(235, 230, 230);
}
.bg-gray-300 {
  background-color: #978f8f;
}

.custom-file-upload {
  border: 1px solid #ccc;
  display: inline-block;
  padding: 6px 12px;
  cursor: pointer;
}
.custom-file-upload-image {
  position: relative;
  top: 100px;
  width: 100%;
}
.cursor-pointer {
  padding: 30px;
}
.image-photo-cover {
  width: 200px;
  position: relative;
  top: -109px;
}
.image-photo {
  height: 170px;
  width: 215px;
  object-fit: cover;
}

.bg-color-light-green{
  margin: 0;
  background-color: rgb(213, 237, 243);
  padding: 15px;
}

.att_cont{
  display: flex;
  height: 315px;
  align-items: center;
  justify-content: center;
  flex-flow: column;
  border-radius: 15px;
}
.coverIdCard{
  /* padding: 10px; */
  border: 1px solid #ccc;
  background-color: #fff;
}
.img-idcard {
  height: 280px;
}
.border-red {
  border-color: red !important;
}

</style>
